import type { UseFetchOptions } from "#app";
import type { IUser, TUserCreditData } from "~/types/global/user.type";

export const useUserStore = defineStore("user", () => {
    type TUserData = TUserCreditData & IUser;

    const apiCallSectionRef = useState<HTMLDivElement | null>("apiCallSectionRef", () => null);
    const enterpriseSectionRef = useState<HTMLDivElement | null>("enterpriseSectionRef", () => null);
    const homepageRef = ref<HTMLDivElement>();
    const showNoActivePlan = ref(false);
    const isUserLoggedIn = ref(false);
    const isMiamiRealtor = ref(false);
    const userData = useState<TUserData>("userData", () => {
        return {} as TUserData;
    });

    const getUserData = async (options?: UseFetchOptions<TUserData>) =>
        await usePublicApi("/account", {
            ...options,
            onResponse({ response }) {
                if (response._data && response.status === 200) {
                    userData.value = response._data as TUserData;
                    setTimeout(() => {
                        isUserLoggedIn.value = true;
                    }, 200);
                }
            },
        });

    const postFirebaseToken = async (payload: any) => {
        await useApi().post("/b2b/leave", { body: payload });
    };

    const isStarterUser = computed(() => {
        if (
            userData.value.restricted_user ||
            userData.value.free_plan ||
            userData.value.can_display_renewal_failed_banner
        ) {
            return true;
        } else false;
    });

    return {
        userData,
        isUserLoggedIn,
        getUserData,
        homepageRef,
        showNoActivePlan,
        postFirebaseToken,
        isStarterUser,
        apiCallSectionRef,
        enterpriseSectionRef,
        isMiamiRealtor,
    };
});
